@if (isOpenMenu) {
  <section class="spen-ly-global-menu-list header-menu-list">
    <div class="menu-list-background" (click)="toggleMenu()"></div>
    <div class="menu-list-wrapper">
      <div class="spen-util-inner">
        @for (menu of globalMenuData; track $index) {
          <div class="menu-item" (click)="toggleMenu()">
            <a class="menu-link" [href]="menu.link_url" [target]="menu.target_blank ? '_blank' : '_self'">
              <img class="menu-icon" [src]="menu.icon_url" /><br />
              @if (menu.batch) {
                <div class="spen-mod-circle-badge is-old-red">
                  <i class="fa fa-exclamation"></i>
                </div>
              }
              <div class="text" [innerHTML]="menu.title"></div>
            </a>
          </div>
        }
      </div>
    </div>
  </section>
}
